import { Component, EventEmitter, Output } from '@angular/core';

@Component({
    selector: 'app-mobile-navbar',
    templateUrl: './mobile-navbar.component.html',
})
export class MobileNavbarComponent {
    @Output() closeMobileMenu: EventEmitter<boolean> = new EventEmitter<boolean>();

    protected closeMenu(): void {
        this.closeMobileMenu.emit(true);
    }
}
